/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_HintInputs */



/**
* | output |
* | --- |
* | "Choose what this connection brings into oneAI, for example its folders. Only organization admins can change this." |
*
* @param {Spaces_Connection_Settings_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_hint = /** @type {((inputs?: Spaces_Connection_Settings_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lege fest, was diese Verbindung in oneAI bringt, zum Beispiel ihre Ordner. Nur Organisations-Admins können das ändern.")
	return /** @type {LocalizedString} */ ("Choose what this connection brings into oneAI, for example its folders. Only organization admins can change this.")
});